import ruRU from 'date-fns/locale/ru';

const ShortLinks = {
  month: 'За месяц',
  threeMonths: 'За 3 месяца',
  sixMonths: 'За пол года',
  year: 'За год',
};

const DateTimeFormats = {
  sunday: 'Вс',
  monday: 'Пн',
  tuesday: 'Вт',
  wednesday: 'Ср',
  thursday: 'Чт',
  friday: 'Пт',
  saturday: 'Сб',
  ok: 'OK',
  today: 'Сегодня',
  yesterday: 'Вчера',
  now: 'Сейчас',
  hours: 'Часы',
  minutes: 'Минуты',
  seconds: 'Секунды',
  formattedMonthPattern: 'MMM yyyy',
  formattedDayPattern: 'dd MMM yyyy',
  shortDateFormat: 'dd/MM/yyyy',
  shortTimeFormat: 'HH:mm',
  dateLocale: ruRU,
};

const Combobox = {
  noResultsText: 'Результатов не найдено',
  placeholder: 'Выберите',
  searchPlaceholder: 'Поиск',
  checkAll: 'Все',
};

const CreatableComboBox = {
  ...Combobox,
  newItem: 'Новый элемент',
  createOption: 'Создать опцию "{0}"',
};

export const ru = {
  code: 'ru',
  common: {
    loading: 'Загрузка...',
    emptyMessage: 'Данные не найдены',
    remove: 'Удалить',
    clear: 'Очистить',
  },
  Plaintext: {
    unfilled: 'Не заполнено',
    notSelected: 'Не выбрано',
    notUploaded: 'Не загружено',
  },
  Pagination: {
    more: 'Больше',
    prev: 'Предыдущая',
    next: 'Следующая',
    first: 'Первая',
    last: 'Последняя',
    limit: '{0} / страница',
    total: 'Общее количество строк: {0}',
    skip: 'Перейти к {0}',
  },
  DateTimeFormats,
  Calendar: DateTimeFormats,
  DatePicker: DateTimeFormats,
  DateRangePicker: {
    ...DateTimeFormats,
    last7Days: 'Последние 7 дней',
  },
  Combobox,
  InputPicker: CreatableComboBox,
  TagPicker: CreatableComboBox,
  Uploader: {
    inited: 'Инициализировано',
    progress: 'Загружается',
    error: 'Ошибка',
    complete: 'Завершено',
    emptyFile: 'Пустой файл',
    upload: 'Загрузить',
    removeFile: 'Удалить файл',
  },
  CloseButton: {
    closeLabel: 'Закрыть',
  },
  Breadcrumb: {
    expandText: 'Показать путь',
  },
  Toggle: {
    on: 'Открыть',
    off: 'Закрыть',
  },
  ShortLinks,
};
